import React from "react";
import { Box, Typography } from "@mui/material";

const EanField = ({ 
  item, 
  idx, 
  showEanField, 
  eanInputs, 
  onEanInputChange, 
  eanValidated, 
  eanRefs, 
  onEanKeyDown 
}) => {
  if (!showEanField) return null;
  
  if (!item.gtin_code) {
    return (
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          minWidth: 120,
          maxWidth: 320,
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 700,
            color: "#ff9800",
            mb: 1,
            fontSize: { xs: "1rem", md: "1.125rem" },
            fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
            letterSpacing: "0.01em",
          }}
        >
          Cod.EAN
        </Typography>
        <Typography
          variant="body2"
          color="warning.main"
          sx={{ fontWeight: 600, color: "#ff9800" }}
        >
          Código não informado
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        minWidth: 120,
        maxWidth: 320,
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{
          fontWeight: 700,
          color: "#ff9800",
          mb: 1,
          fontSize: { xs: "1rem", md: "1.125rem" },
          fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
          letterSpacing: "0.01em",
        }}
      >
        Cod.EAN
      </Typography>
      
      <Box
        component="input"
        type="text"
        placeholder="Escaneie o Código"
        value={eanInputs[idx] || ""}
        onChange={(e) => onEanInputChange(idx, e.target.value)}
        ref={
          eanRefs?.current
            ? (el) => (eanRefs.current[idx] = el)
            : undefined
        }
        onKeyDown={
          onEanKeyDown
            ? (e) => onEanKeyDown(idx, e)
            : undefined
        }
        sx={{
          width: "100%",
          borderRadius: 2,
          border: eanValidated[idx]
            ? "2px solid #4caf50"
            : "1.5px solid #ff9800",
          fontSize: "1rem",
          fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
          padding: "12px 16px",
          boxSizing: "border-box",
          backgroundColor: eanValidated[idx] ? "#e8f5e9" : "#fffbe6",
          color: "#333",
          transition: "all 0.2s ease-in-out",
          outline: "none",
          "&:focus": {
            borderColor: eanValidated[idx] ? "#4caf50" : "#ff9800",
            boxShadow: eanValidated[idx]
              ? "0 4px 12px rgba(76, 175, 80, 0.15)"
              : "0 4px 12px rgba(255, 152, 0, 0.15)",
          },
          "&::placeholder": {
            color: "#bdbdbd",
            fontWeight: 400,
          },
        }}
      />
      
      {eanInputs[idx] && !eanValidated[idx] && (
        <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
          Código incorreto, tente novamente.
        </Typography>
      )}
      
      {eanValidated[idx] && (
        <Typography variant="caption" color="success.main" sx={{ mt: 0.5 }}>
          Produto correto! Pronto para imprimir.
        </Typography>
      )}
    </Box>
  );
};

export default EanField;